"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReconnectModule = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _components = require("../../../components");
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ReconnectModule = function ReconnectModule(_ref) {
  var owner = _ref.owner,
    members = _ref.members;
  var isPatientOwnedChatWithTherapist = (0, _lodash.size)(members) === 2 && (0, _utils.isPatient)(owner) && (0, _lodash.find)(members, {
    user: {
      applicationRole: _utils.UserRoles.Therapist
    }
  });
  if (!isPatientOwnedChatWithTherapist) {
    return null;
  }

  // @TODO: 👉 When the reconnect to therapist feature is developed more,
  // and does more than just open the support form, the logic and button label
  // here should be updated.

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full border-0 border-solid border-t-[1px] border-grey-20 bg-white py-[20px] px-[25px] lg:py-[40px] flex flex-col justify-evenly gap-x-[6%] items-center md:flex-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col justify-center"
  }, "You can read old messages but cannot send a new message because you are no longer matched to this therapist."), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    id: "monument-chat-reconnect-therapist",
    size: "large",
    className: "px-[82px] mt-[24px] min-w-[330px]",
    url: _utils.SUPPORT_URL
  }, "Request to re-connect")));
};
exports.ReconnectModule = ReconnectModule;